# Validation status filter: only shows issues with validation_status = "FAILED"
query Issues(
	$runId: ConditionID!
	$textSearch: issuesSearchInsensitive
	$urlFilter: ConditionString
	$severityIdFilter: ConditionString
	$typeIdFilter: ConditionString
	$levelFilter: ConditionString
	$offset: Int
	$limit: Int
	$sort: issuesSort
	$propertiesFilter: ConditionID
) {
	issues(
		run_id_eq: $runId
		url_eq: $urlFilter
		severity_name_eq: $severityIdFilter
		type_name_eq: $typeIdFilter
		conformance_eq_any_item: $levelFilter
		offset: $offset
		limit: $limit
		sort: $sort
		text_contains: $textSearch
		property_ids_eq_any_item: $propertiesFilter
		validation_status_eq: { value: "FAILED" }
	) {
		issue_id
		signature
		url
		severity_name
		type_name
		elements__component_id
		elements__selector
		elements__dom_snippet
		page_title
		analysis_time
		screenshot
		elements__bounding_box_left
		elements__bounding_box_top
		elements__bounding_box_width
		elements__bounding_box_height
		validation_status
		summary
		description
		knowledge_base_link
		tags__id
		tags__link
		note
	}

	total: issues(
		run_id_eq: $runId
		url_eq: $urlFilter
		severity_name_eq: $severityIdFilter
		type_name_eq: $typeIdFilter
		conformance_eq_any_item: $levelFilter
		text_contains: $textSearch
		property_ids_eq_any_item: $propertiesFilter
		validation_status_eq: { value: "FAILED" }
	) {
		issue_id_count
	}

	unfiltered_total: issues(run_id_eq: $runId, validation_status_eq: { value: "FAILED" }) {
		issue_id_count
	}
}
